export const environment = {
  // API Configuration
  API_BASE_URL: 'https://api.dev.datanex.adb.org',

  // Microsoft Authentication Library (MSAL) Configuration
  MSAL_CLIENT_ID: 'dff76e0f-4bc2-4279-ae60-9c201532849e',
  MSAL_AUTHORITY: 'https://login.microsoftonline.com/9495d6bb-41c2-4c58-848f-92e52cf3d640',
  // TODO: is the below necessary?
  MSAL_LOGIN_REQUEST_SCOPE: '',
  DATANEX_SUPPORT_EMAIL: 'datanex-dev@adb.org',
};
